import Wrapper from '../components/global/Wrapper';
import ApplyForLoansImage from '../assets/images/dashboard-business/loansApply.svg';
import { bsf } from '../utils/constants';
import { registerNetcoreActivity } from '../utils/registerActivity';
import ReactGA from 'react-ga4';
import { useAppSelector } from '../app/hooks';

const LoanPage = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const token: any = localStorage.getItem('login-token');
  const details = useAppSelector((state) => state.auth.loggedInUserDetails);

  const handleClick = () => {
    window.location.href = `${bsf}?tk=${token}&email=${details?.email}}`;
    registerNetcoreActivity(
      {
        emailAddress: details?.email,
        firstName: details?.firstName,
        lastName: details?.lastName,
        mobileNumber: details?.phoneNumber,
      },
      'TBH_BOOK_LOAN',
    );
    ReactGA.event({
      category: 'formSubmit',
      action: 'TBH_BOOK_LOAN',
      label: 'TBH_BOOK_LOAN',
      // value: 1
    });
  };

  return (
    <>
      <Wrapper className=' space-y-3 pt-[12px] md:pt-12 md:space-y-8  !mr-0'>
        <div
          style={{
            height: '100vh',
            // backgroundColor: 'red',
            paddingBottom: '5rem',
            paddingTop: '3rem',
          }}
        >
          <div
            style={{
              justifyContent: 'center',
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            <div className='h-[300px] w-[400] mb-7'>
              <img
                className='h-[100%] w-[100%]'
                src={ApplyForLoansImage}
                alt='loans illustration image'
              />
            </div>
            <span className=' text-green mt-12'>
              Get access to loans up to 5 million naira in{' '}
              <span
                style={{
                  borderBottom: '3px solid #229698',
                }}
              >
                5 minutes
              </span>
            </span>
            <p
              style={{
                borderRadius: '3px',
                padding: '10px',
              }}
              className='h-[50px] cursor-pointer w-[200px] bg-green text-white mt-7 text-center font-Poppins text-xl'
              onClick={handleClick}
            >
              Apply Now
            </p>
          </div>
        </div>
      </Wrapper>
    </>
  );
};

export default LoanPage;
